// extracted by mini-css-extract-plugin
module.exports = {"blogName":"hero-module--blogName--M426Z","blogDesc":"hero-module--blogDesc--3JkZa","heroSection":"hero-module--heroSection--3RTpi"};